import "what-input";
import Vue from "vue";
import { instance } from "./api/instance.js";
import BurgerMenu from "./components/BurgerMenu.vue";
import { gsap, ScrollTrigger } from "gsap/all";

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below

gsap.registerPlugin(ScrollTrigger); 

// Locomotive
import LocomotiveScroll from "locomotive-scroll";

// Use API
Vue.prototype.$http = instance;

// Enable to use Vue.js
var vue = new Vue({
  el: "#app",
  components: { 
    "burger-menu": BurgerMenu,
  },
  data: {
  	menu_active: false
  },
  mounted() {
    console.log("Running Vue.js");
  },
  methods: {
  	toggle_menu: function() {
  		this.menu_active = !this.menu_active;
  	}
  }
});


(function($) {
    $(document).ready(function() { // Loaded when DOM is ready
        console.log("Running jQuery");

        window.addEventListener('scroll', () => {
          document.querySelector('#hero').style.top = window.scrollY * -0.0150;
          // this.parallaxTop = 	window.scrollY * -0.0150;
        });

        let scroll = new LocomotiveScroll({
          el: document.querySelector("[data-scroll-container]"),
          smooth: true,
          lerp: 0.1
        });

        $('img').each(function(i, img) {
          $(img).on('load', () => {
            updateScroll();
          })
        });
        
        $(".toggle-menu-scroll").on("click", () => {
          if(vue.menu_active) {
            stopScroll();
          } else {
            startScroll();
          }
        })

        function stopScroll() {
          scroll.stop();
          $("body").css("overflow", "hidden");
        }

        function startScroll() {
          scroll.start();
          $("body").css("overflow", "visible");
        }

        setTimeout(() => {
          console.log("Scroll updated");
          scroll.update(); 
        }, 2000);

        //sticky menu
        const body = document.body;
        const scrollUp = "scroll-up";
        const scrollDown = "scroll-down";
        let lastScroll = 0;
        let quoteAuto = false;
 
        scroll.on("scroll", (position) => { 
          // document.querySelector(".is-inview").classList.add("stay-active");
          document.querySelector('#hero').style.top = position.scroll.y * 0.150 + 'px';

          if ((position.scroll.y) >= 50) {
            $("body").addClass("is-scrolled");
            $("header").addClass("is-active");
          } else {
            $("body").removeClass("is-scrolled");
            $("header").removeClass("is-active");
          }

          const currentScroll = position.scroll.y;
          if (currentScroll <= 0) {
            body.classList.remove(scrollUp);
            return; 
          }
          
          if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
            // down
            body.classList.remove(scrollUp);
            body.classList.add(scrollDown);
          } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
            // up
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);
          }
          lastScroll = currentScroll;
        });

        function updateScroll() {
          setTimeout(() => {
            scroll.update();
            console.log("SCROLL UPDATED"); 
          }, 150);
        }

        jQuery(document).on('gform_confirmation_loaded', function(event, formId){
          scroll.update(); 
      });
    });
})( jQuery );